import React__default, { useState } from 'react';
import './NavDrawer.css.js';

function NavigationDrawer({ links, position = "left", width = "280px", }) {
    const [open, setOpen] = useState(false);
    const toggleDrawer = () => setOpen(!open);
    const closeDrawer = () => setOpen(false);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("button", { className: `drawer-toggle toggle-${position}`, onClick: toggleDrawer, "aria-label": "Toggle navigation" }, "\u2630"),
        open && React__default.createElement("div", { className: "drawer-overlay", onClick: closeDrawer }),
        React__default.createElement("div", { className: `drawer drawer-${position} ${open ? "open" : ""}`, style: { width } },
            React__default.createElement("button", { className: "drawer-close", onClick: closeDrawer }, "\u2715"),
            React__default.createElement("ul", { className: "drawer-menu" }, links.map((link, i) => (React__default.createElement("li", { key: i, className: "drawer-item" },
                React__default.createElement("a", { href: link.href, onClick: closeDrawer }, link.label))))))));
}

export { NavigationDrawer };
//# sourceMappingURL=NavDrawer.js.map
